import { ApiError } from './api';
import { useAuthStore } from './auth-store';

/** EC1 reads use its dedicated same-origin control route and shared Discord session. */
export async function adminGameRequest<T>(path: string, signal?: AbortSignal): Promise<T> {
  const session = useAuthStore.getState().me;
  const response = await fetch(`/api/classic-admin${path}`, { credentials: 'include', signal });
  if (response.status === 401 && useAuthStore.getState().me === session) useAuthStore.getState().clear();
  if (!response.ok) throw new ApiError(response.status, response.status === 503
    ? 'Epic Conquest Classic is temporarily unavailable. Please retry.'
    : `Unable to load admin data (HTTP ${response.status}).`);
  return response.json() as Promise<T>;
}
export interface AdminGame { id: 'ec1' | 'ec2'; label: string; available: boolean }
export async function getAdminGames(signal?: AbortSignal): Promise<{ games: AdminGame[] }> {
  const session = useAuthStore.getState().me;
  signal?.throwIfAborted();
  if (!session) throw new ApiError(401, 'Sign in to load admin workspaces.');
  const capabilities = await adminGameRequest<{ game?: string; role?: string; canWrite?: boolean }>('/capabilities', signal);
  if (useAuthStore.getState().me !== session) throw new ApiError(401, 'Admin session changed. Please retry.');
  if (capabilities.game !== 'ec1' || typeof capabilities.role !== 'string' || typeof capabilities.canWrite !== 'boolean')
    throw new ApiError(503, 'Epic Conquest Classic is temporarily unavailable. Please retry.');
  return { games: [
    { id: 'ec2', label: 'Epic Conquest 2', available: true },
    { id: 'ec1', label: 'Epic Conquest Classic', available: true },
  ] };
}
export function adminGameFromLocation(pathname: string, search: string) {
  return pathname === '/games/ec1' || pathname.startsWith('/games/ec1/') || (pathname === '/admins' && new URLSearchParams(search).get('game') === 'ec1') ? 'ec1' : 'ec2';
}
